import { createInertiaApp } from '@inertiajs/react'
import type { ComponentType, ReactNode } from 'react'
import AdminLayout from '@/layouts/admin-layout'
import AuthLayout from '@/layouts/auth-layout'

// biome-ignore lint/suspicious/noExplicitAny: pages have heterogeneous props
type PageComponent = ComponentType<any> & { layout?: (page: ReactNode) => ReactNode }
const pages = import.meta.glob<{ default: PageComponent }>('../pages/**/*.tsx', { eager: true })

void createInertiaApp({
  // Layout comes from the page's area: admin/* gets the console chrome, auth/* the bare card.
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) throw new Error(`Unknown Inertia page: ${name}`)
    if (name.startsWith('admin/')) {
      page.default.layout ??= (p: ReactNode) => <AdminLayout>{p}</AdminLayout>
    } else if (name.startsWith('auth/')) {
      page.default.layout ??= (p: ReactNode) => <AuthLayout>{p}</AuthLayout>
    }
    return page
  },

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => ({ queryStringArrayFormat: 'brackets' }),
  },
})
